module.exports = __webpack_public_path__ + "media/images/icons/flags/TR-bb75f2dea544ce9aa2d7cecd8ab95807.svg";